import { Component, OnInit, AfterContentInit, inject } from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { MainDashboardInterface } from '../../models';
import { CreateSspService } from '../../services';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-create-ssp-dialog',
  templateUrl: './create-ssp-dialog.component.html',
  styleUrls: ['./create-ssp-dialog.component.scss'],
  standalone: false
})
export class CreateSspDialogComponent implements OnInit, AfterContentInit {
  protected formHeight = 'auto';

  public data = inject(NZ_MODAL_DATA) as MainDashboardInterface.ICreateSSPDialog;

  constructor(
    public dialogRef: NzModalRef<CreateSspDialogComponent>,
    protected createSspService: CreateSspService,
  ) { }

  public ngOnInit(): void {
    this.createSspService.initializeData(this.data);
    (this.createSspService.newSSPForm.get('isVideo') as FormControl).valueChanges.subscribe(value => {
      this.createSspService.onChangeVideoFormatHandler(value);
    });

    (this.createSspService.newSSPForm.get('isAudio') as FormControl).valueChanges.subscribe(value => {
      this.createSspService.onChangeAudioFormatHandler(value);
    });

    (this.createSspService.newSSPForm.get('rewarded') as FormControl).valueChanges.subscribe(value => {
      this.createSspService.onChangeRewardedFormatHandler(value);
    });

    (this.createSspService.newSSPForm.get('connectionType') as FormControl).valueChanges.subscribe((value) => {
      this.createSspService.onChangeConnectionTypeHandler(value);
    });

    (this.createSspService.newSSPForm.get('pixalate_pb_settings')?.get('ip') as FormControl).valueChanges.subscribe((value) => {
      this.createSspService.onChangePixalatePreBidIpHandler(value);
    });

    (this.createSspService.newSSPForm.get('pixalate_pb_settings')?.get('ifa') as FormControl).valueChanges.subscribe((value) => {
      this.createSspService.onChangePixalatePreBidIFAHandler(value);
    });

    (this.createSspService.newSSPForm.get('pixalate_pb_settings')?.get('hr_app') as FormControl).valueChanges.subscribe((value) => {
      this.createSspService.onChangePixalatePreBidBundleHandler(value);
    });

    (this.createSspService.newSSPForm.get('region') as FormControl).valueChanges.subscribe((value) => {
      this.createSspService.onEndpointRegionChangeHandler(value);
    });

    (this.createSspService.newSSPForm.get('is_multi_ad_response') as FormControl).valueChanges.subscribe((value) => {
      if (value) {
        this.createSspService.newSSPForm.get('multi_ad_responses')?.setValue(10);
      } else {
        this.createSspService.newSSPForm.get('multi_ad_responses')?.reset();
      }
    });
  }

  public ngAfterContentInit(): void {
    this.formHeight = window.innerHeight - 20 + 'px';
    window.addEventListener('resize', () => {
      this.formHeight = window.innerHeight - 20 + 'px';
    });
  }

  protected get hasScanner(): boolean {
    return this.createSspService.hasScanner;
  }

  protected onChangeVastEndpoint(vastEndpoint: string): void {
    this.createSspService.onChangeVastEndpointHandler(vastEndpoint);
  }

  protected onChangeVastMacrosList(macrosList: string[]): void {
    this.createSspService.onChangeVastMacrosListHandler(macrosList);
  }

  protected isBotmanPreBidIsEnabled(): boolean {
    return this.createSspService.isBotmanPreBidIsEnabled();
  }

  protected isBotmanPostBidIsEnabled(): boolean {
    return this.createSspService.isBotmanPostBidIsEnabled();
  }

  protected isFraudSensorEnabled(): boolean {
    return this.createSspService.isFraudSensorEnabled();
  }

  protected isMediaGuardEnabled(): boolean {
    return this.createSspService.isMediaGuardEnabled();
  }

  protected isFraudLogixEnabled(): boolean {
    return this.createSspService.isFraudLogixEnabled();
  }

  protected isNovoroll(): boolean {
    return this.createSspService.isPartnerNovoroll();
  }

  protected onChangeActive(value: boolean): void {
    this.createSspService.onChangeActiveHandler(value);
  }

  protected onTagTypeChange(type: string): void {
    this.createSspService.onTagTypeChangeHandler(type);
  }

  protected onSubmit() {
    this.createSspService.onSubmitForm(() => this.dialogRef.close('created'));
  }

  protected onCancel(): void {
    this.createSspService.onCloseModal(() => this.dialogRef.close('cancel'));
  }

  protected onPreventInput(event: Event, field: string): void {
    this.createSspService.onPreventInputHandler(event, field);
  }

  protected onCompanyChange(val: number): void {
    this.createSspService.onCompanyChangeHandler(val);
  }

  protected async onApiLinkTest(link: string, e: Event): Promise<void> {
    return await this.createSspService.onApiLinkTestHandler(link, e);
  }

  protected onValidateLink(link: string, event: Event): void {
    this.createSspService.onValidateLinkHandler(link, event);
  }

  protected getError(value: boolean): void {
    this.createSspService.getError(value);
  }

  protected onChangeChecked(value: boolean, element: string): void {
    this.createSspService.onChangeDemandBoosterValueHandler(value, element);
  }

  protected onChangeBCATCheckboxState(value: boolean): void {
    this.createSspService.onChangeBCATCheckboxStateHandler(value);
  }

  protected onChangeCustomAdapters(server: string | number): void {
    this.createSspService.onChangeCustomAdaptersHandler(server);
  }

  protected onChangeInput(value: Event) {
    this.createSspService.onChangeAdapterFieldHandler(value);
  }

  protected onChangeAdType() {
    this.createSspService.onChangeAdTypeHandler();
  }

  protected onChangeMarginType(type: string): void {
    this.createSspService.onChangeMarginTypeHandler(type);
  }

  protected onChangeDefaultBidfloor() {
    this.createSspService.onChangeDefaultBidfloorHandler();
  }

  protected onChangeSize(id: number): void {
    this.createSspService.onChangeSizeHandler(id);
  }

  protected onValidateSpaceForName() {
    this.createSspService.onValidateSpaceForNameHandler();
  }

  protected onChangeMacros(selectedItems: string[]) {
    this.createSspService.onChangeMacrosHandler(selectedItems);
  }

  protected isRequiredAdapterField(itemName: string): boolean {
    return this.createSspService.getIsRequiredAdapterField(itemName);
  }
}
